import client from '../client';
import endpoints from '../endpoints';

/**
 * 인증 서비스 — API_DOCS: 1. 인증 (Auth)
 * 인증은 항상 real API 호출 (dummy 없음)
 */
export const authService = {
  signup: (data) => client.post(endpoints.auth.signup, data).then((r) => r.data),
  login: (data) => client.post(endpoints.auth.login, data).then((r) => r.data),
  logout: () => client.post(endpoints.auth.logout).then((r) => r.data),
  getMe: () => client.get(endpoints.auth.me).then((r) => r.data),
  oAuth: (provider, data) => client.post(endpoints.auth.oAuth(provider), data).then((r) => r.data),
  passwordResetRequest: (data) => client.post(endpoints.auth.passwordResetRequest, data).then((r) => r.data),
  passwordReset: (data) => client.post(endpoints.auth.passwordReset, data).then((r) => r.data),
  guestVerify: (data) => client.post(endpoints.auth.guestVerify, data).then((r) => r.data),
  guestConfirm: (data) => client.post(endpoints.auth.guestConfirm, data).then((r) => r.data),
};
